module.exports = __webpack_public_path__ + "static/media/5DPO4.e0a33425.jpg";